import AdminLayout from "./AdminLayout";
import ContentManagement from "./ContentManagement";

function Content() {
  return (
    <AdminLayout>
      <ContentManagement />
    </AdminLayout>
  );
}

export default Content;
